// Quote-related filters

import {
	createDateRangeFilter,
	createEntityLookupFilter,
	createKeywordFilter,
} from './factories';
import type { FilterRegistry } from './types';

export const quoteFilters: FilterRegistry = {
	quoteKeywords: {
		...createKeywordFilter({
			label: 'Search Quotes',
			placeholder: 'Search by quote number, client name...',
			objectTable: 'order',
			listKeys: ['quote', 'quote-client-embedded'],
			fulltextFields: [
				'externalId',
				'externalId2',
				'_id',
				'c.name',
				'c.externalId',
				'c.externalId2',
			],
		}),
		queryParamName: 'quoteKeywords',
	},

	quoteSalesRep: {
		type: 'multi-select',
		label: 'Client Sales Rep',
		placeholder: 'Select sales representatives...',
		colorScheme: 'blue',
		searchable: true,
		loadOnFocus: true,
		displayFields: {
			id: 'salesperson_id' as keyof unknown,
			primary: 'display_name' as keyof unknown,
		},
		queryParamName: 'quoteSalesRep',
		apiEndpoint: '/users/salespeople',
		multiple: true,
		options: [
			{ id: 'ME', label: 'Me' },
			{ id: 'null', label: 'Unassigned' },
		],
		queryMapping: {
			objectTable: 'order',
			fieldName: '_fk_user__id',
			joinType: 'custom',
		},
		format: 'array',
		valueExtractor: {
			property: 'id',
		},
		listKeys: ['quote', 'quote-client-embedded'],
	},

	quoteDateRange: {
		...createDateRangeFilter({
			label: 'Quote Date',
			objectTable: 'order',
			dateField: 'createdDate',
			listKeys: ['quote', 'quote-client-embedded'],
		}),
		queryParamName: 'quoteDateRange',
	},

	quoteClient: {
		...createEntityLookupFilter({
			label: 'Client',
			placeholder: 'Search clients...',
			apiEndpoint: '/clients',
			objectTable: 'order',
			fieldName: '_fk_client__id',
			listKeys: ['quote', 'quote-client-embedded'],
			displayFields: {
				id: 'id',
				primary: 'name',
				secondary: 'externalId',
			},
			colorScheme: 'green',
		}),
		searchFilterName: 'clientSearch',
		apiParams: {
			page: '1',
			limit: '10',
			fields: JSON.stringify(['client.id', 'client.name', 'client.externalId']),
		},
		queryParamName: 'quoteClient',
		valueExtractor: {
			property: 'id',
			transform: 'number',
		},
	},

	quoteStatus: {
		type: 'multi-select',
		label: 'Status',
		placeholder: 'Select quote statuses...',
		colorScheme: 'orange',
		searchable: false,
		loadOnFocus: false,
		allowClear: true,
		displayFields: {
			id: 'id' as keyof unknown,
			primary: 'label' as keyof unknown,
		},
		queryParamName: 'quoteStatus',
		multiple: true,
		options: [
			{ id: 'open', label: 'Open' },
			{ id: 'closed', label: 'Closed' },
			{ id: 'needsReview', label: 'Needs Review' },
		],
		queryMapping: {
			objectTable: 'order',
			fieldName: 'status',
			joinType: 'custom',
		},
		format: 'array',
		valueExtractor: {
			property: 'id',
		},
		listKeys: ['quote', 'quote-client-embedded'],
	},
};
